import ApiModel from 'models/api-model';
import {
  getLanguagesMenuOptions,
  getDateFormatMenuOptions,
  getNumberFormatMenuOptions,
  getCurrencyMenuOptions,
} from 'constants/feature/statement-creation-constants';
import { isNullOrUndefined } from 'utils/object-utils';

export default class StatementCreationPageData extends ApiModel({
  data: {
    languages: [],
    dateFormat: [],
    numberFormat: [],
    currency: [],
  },
}) {
  languageMenuOptions(isPdfSelected) {
    return !isNullOrUndefined(this.data.languages)
      ? getLanguagesMenuOptions(this.data.languages, isPdfSelected)
      : [];
  }

  getLanguageDropdownValues(isPdfSelected, searchTerm) {
    if (searchTerm.length) {
      const languageData = this.languageMenuOptions(isPdfSelected);
      return Object.values(languageData).filter(
        (obj) =>
          obj.title.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1,
      );
    }
  }

  get languageData(){
    return !isNullOrUndefined(this.data.languages)
      ? this.data.languages
      : [];
  }

  get languagesMenuOptions() {
    return !isNullOrUndefined(this.data.languages)
      ? getLanguagesMenuOptions(this.data.languages)
      : [];
  }

  get dateFormatMenuOptions() {
    return !isNullOrUndefined(this.data.dateFormat)
      ? getDateFormatMenuOptions(this.data.dateFormat)
      : [];
  }

  get numberFormatMenuOptions() {
    return !isNullOrUndefined(this.data.numberFormat)
      ? getNumberFormatMenuOptions(this.data.numberFormat)
      : [];
  }

  get currencyMenuOptions() {
    return !isNullOrUndefined(this.data.currency)
      ? getCurrencyMenuOptions(this.data.currency)
      : [];
  }

  selectedLanguageValue(languageValue) {
    if (isNullOrUndefined(languageValue)) {
      return [];
    }
    return (
      this.data.languages &&
      this.data.languages.filter(
        (item) => item.languageCode === languageValue,
      )[0]
    );
  }

  selectedDateFormatValue(dateFormatValue) {
    if (isNullOrUndefined(dateFormatValue)) {
      return [];
    }
    return (
      this.dateFormatMenuOptions &&
      this.dateFormatMenuOptions.filter(
        (item) => item.id === dateFormatValue,
      )[0]
    );
  }

  selectedNumberFormatValue(numberFormatValue) {
    if (isNullOrUndefined(numberFormatValue)) {
      return [];
    }
    return (
      this.numberFormatMenuOptions &&
      this.numberFormatMenuOptions.filter(
        (item) => item.value === numberFormatValue,
      )[0]
    );
  }

  selectedCurrencyValue(currency) {
    if (isNullOrUndefined(currency)) {
      return [];
    }
    const currencyMenuOptions = this.currencyMenuOptions?.filter(
      (item) => item.value === currency,
    )[0];
    return isNullOrUndefined(currencyMenuOptions) ? [] : currencyMenuOptions;
  }

  processResponse({ result }) {
    return {
      data: {
        languages: result && result.languageDetails,
        dateFormat: result && result.dateFormats,
        numberFormat: result && result.numberFormats,
        currency: result && result.currencies,
      },
    };
  }
}
